import styled from 'styled-components';

import { flex, media } from '@/styles/theme';

interface ISectionContainer {
  topMargin?: string | undefined;
  bottomMargin?: string | undefined;
}

const DefaultContainer = styled.div.attrs({
  className: `${flex.column} flex-grow-1 px-3`,
})``;

const SectionContainer = styled.div<ISectionContainer>`
  margin-top: 16px;
  margin-bottom: ${props => props.bottomMargin};

  @media (min-width: 768px) {
    background: #f5f5f5;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
    border-radius: 8px;
    padding: 16px 24px;
    margin-top: 0;
  }
`;

const MainContainer = styled(DefaultContainer)<{ padding?: string; width?: string }>`
  padding: 11px 8px;

  ${media.tablet} {
    padding-left: 75px !important;
    padding-right: 75px !important;
  }

  ${media.laptop} {
    padding-left: ${props => (props.padding ? props.padding : '145px !important')};
    padding-right: ${props => (props.padding ? props.padding : '145px !important')};
  }

  @media (min-width: 1140px) {
    width: ${props => (props.width ? props.width : '1140px')};
    margin: 10px 0;
    justify-content: center;
    width: auto;
  }
`;

const FormControlContainer = styled.div.attrs({
  className: 'pt-4 d-flex border-top justify-content-end',
})`
  border-color: #d8d8d8;

  @media (max-width: 768px) {
    justify-content: space-around !important;

    & > button {
      flex-grow: 1;
      margin-left: 0 !important;

      :last-child {
        margin-left: 16px !important;
      }
    }
  }
`;

const TitleContainer = styled.div.attrs({
  className: 'd-flex justify-content-between w-100',
})``;

export { MainContainer, FormControlContainer, SectionContainer, TitleContainer };
